import { Card } from "../Card";
import { Skeleton } from "../Skeleton";
import { EncabezadoPaginaSkeleton } from "./EncabezadoPaginaSkeleton";
import { RegionCargando } from "./RegionCargando";

/**
 * Página genérica en carga (título + subtítulo + tarjeta con filas) · es el
 * `defaultPendingComponent` del router: se pinta DENTRO del shell (header y
 * sidebar quedan visibles) mientras el loader de la ruta destino resuelve.
 */
export function PageSkeleton({ filas = 6 }: { filas?: number }) {
  return (
    <RegionCargando etiqueta="Cargando página…" className="w-full px-4 py-6 md:px-6">
      <EncabezadoPaginaSkeleton />
      <Card aria-hidden="true">
        <div className="flex flex-col gap-4">
          {Array.from({ length: filas }, (_, i) => (
            <div key={i} className="flex items-center gap-4">
              <Skeleton height={14} width="18%" />
              <Skeleton height={14} className="flex-1" />
              <Skeleton height={14} width="12%" />
            </div>
          ))}
        </div>
      </Card>
    </RegionCargando>
  );
}
